const CHECKOUT_BUTTON_SELECTOR = 'a.Button.Button--primary[href="/checkout"]';

function initializeWidget() {
  window.localStorage.setItem(
    "com.shield:checkoutButtonSelector",
    CHECKOUT_BUTTON_SELECTOR
  );

  const checkoutButton = document.querySelector(CHECKOUT_BUTTON_SELECTOR);

  if (checkoutButton && !document.querySelector("shield-widget")) {
    console.log("initializing widget creating element");
    const shieldWidget = document.createElement("shield-widget");
    checkoutButton.parentNode.insertBefore(shieldWidget, checkoutButton);
  }
}

// Create a mutation observer to watch for DOM changes
const observer = new MutationObserver(() => {
  initializeWidget();
});

// Start observing the entire document for changes
observer.observe(document.body, {
  childList: true,
  subtree: true,
});

// Initial check in case the button is already present
initializeWidget();

document.addEventListener("minicart:refreshed", () => {
  initializeWidget();
});

console.log("shieldjs");
